import { VDBText } from "@components/atoms";
import Container from "@components/atoms/Container";
import VDBIcon, { IconsVariant } from "@components/icons/VDBIcon";
import { TouchableOpacity, View } from "react-native";
import TextSearchProductType from "@components/atoms/TextSearch/TextSearchProductType";
import styled from "styled-components/native";
import { Divider } from "@gluestack-ui/themed";
import { SpaceType } from "@components/atoms/Spacer/types";
import { VDBIcons } from "@utils/VDBIcons";
import Routes from "@navigations/Routes";
import { navigate } from "@navigations/utils/RootNavigation";
import { useTypographyStore } from "@redux/slices/typographySlice";
import { useTheme } from "styled-components/native";
import { ProductCategory } from "@utils/constants";
import { useTranslation } from "react-i18next";
import { useProductPrefix } from "../../hooks/useProductPrefix";
import { SearchFilterTypeEnum } from "@components/atoms/Filters/utils";
import { StoneType } from "@scenes/bulk-request/Utils";

const RenderSectionHeader = ({
  title,
  headerData,
  showResultsAsTooltip,
  dataCount,
  NUMBER_OF_RECORDS_TO_AGGREGATE,
  inputValue,
  setInputValue,
}: any) => {
  const typography = useTypographyStore();
  const theme = useTheme();
  const { t } = useTranslation();
  const productPrefix = useProductPrefix();
  const [productTypeCategory, subProductTypeCategory] = title.split("_");
  return (
    <Container {...(theme.isTablet && { applyMaxWidth: false })}>
      <TextSearchProductType
        productId={productTypeCategory}
        subProductTypeCategory={subProductTypeCategory}
        showResultsAsTooltip={showResultsAsTooltip}
      />
      {showResultsAsTooltip && dataCount > NUMBER_OF_RECORDS_TO_AGGREGATE && (
        <View>
          <TouchableOpacity
            style={{
              flexDirection: "row",
              flexGrow: 1,
              flexShrink: 0,
              justifyContent: "space-between",
              alignItems: "center",
              paddingBottom: 16,
              paddingTop: 8,
            }}
            onPress={() => {
              setInputValue("");
              const params = {
                productType:
                  productTypeCategory === "0"
                    ? ProductCategory.DIAMOND.toString()
                    : productTypeCategory === "1"
                    ? ProductCategory.LAB_GROWN_DIAMOND.toString()
                    : productTypeCategory === "2"
                    ? ProductCategory.GEMSTONE.toString()
                    : ProductCategory.JEWELRY.toString(),
                searchText: inputValue,
                sectionName:
                  subProductTypeCategory === StoneType.PAIR
                    ? SearchFilterTypeEnum.PAIRS
                    : subProductTypeCategory === StoneType.PARCELS
                    ? SearchFilterTypeEnum.PARCEL
                    : SearchFilterTypeEnum.SINGLE_STONES,
                productPrefix,
              };
              navigate(Routes.ExploreNavigator, {
                screen: Routes.FilterSplitScreen,
                params,
              });
            }}
          >
            <GroupedResultsView>
              <VDBText
                type={typography["Body-M"]}
                isBold={true}
                color={theme["core-05"]}
              >
                {t("textSearchScreen.header.text", {
                  headerdata: headerData.length,
                })}
              </VDBText>
              <VDBText type={typography["Body-R"]}>
                {t("textSearchScreen.header.screenText.text")} {inputValue}
              </VDBText>
            </GroupedResultsView>
            <VDBIcon
              color={theme["core-04"]}
              size={SpaceType.Big}
              variant={IconsVariant.VDBCustom}
              name={VDBIcons.ARROW_RIGHT}
            />
          </TouchableOpacity>
          <Divider />
        </View>
      )}
    </Container>
  );
};

const GroupedResultsView = styled.View`
  border-radius: 8px;
`;

export default RenderSectionHeader;
